module.exports = __webpack_public_path__ + "img/skootar_charge_logo.c66480ba.png";